import { ChangeDetectorRef, Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { BaseService } from 'src/app/_services/base.service';

@Component({
  selector: 'search-book-address',
  templateUrl: './search-book-address.component.html',
  styleUrls: ['./search-book-address.component.scss']
})
export class SearchBookAddressComponent implements OnInit {
	@Output() selectRecord: EventEmitter<any> = new EventEmitter();
	
	rows: any[] = [];
	recordsTotal: number = 0;
	recordsPerPage: number = 10;		// records per page
	currentPage = 1;

	filters = {};
	dataLoadingFlag: boolean = true;
	public searchTerm:string="";
	constructor(private cdref: ChangeDetectorRef, 
		private spinner: NgxSpinnerService,
		private toastr: ToastrService,
		private baseService: BaseService) { }

	ngOnInit(): void {
		this.renderData();
	}

	renderData() {
		this.filters = {
			q: this.searchTerm,
			page: this.currentPage,
			limit: this.recordsPerPage,
		};

		this.dataLoadingFlag = true;
		// this.spinner.show();
		this.baseService.getAddressList(this.filters).subscribe((data:any) => {
			console.log(data);
			if (data == null) {
				this.rows = [];
				this.recordsTotal = 0;
			} else {
				this.rows = [];
				const remoteRows: any = [];
				data.forEach((record: any) => {
					remoteRows.push(
						{
							id: record.id,
							name: record.name,
							firstname: record.firstname,
							lastname: record.lastname,
							company_name: record.company_name,
							email: record.email,
							contact_no: record.contact_no,
							address1: record.address1,
							address2: record.address2,
							postcode: record.postcode,
							state: record.state,
							suburb: record.suburb,
							country: record.country,
							label: record.label,
						}
					);
				});

				this.rows = remoteRows;
				this.recordsTotal = data.total;
			}

			// this.spinner.hide();
			this.dataLoadingFlag = false;
			this.cdref.detectChanges();
		}, (err) => {
			// this.spinner.hide();
			console.log('data error: ', err);
			// this.cdref.detectChanges();
		});
	}

	reload() {
		this.renderData();
	}

	get numbers(): number[] {
		const limit = Math.ceil((this.rows && this.recordsTotal) / this.recordsPerPage);
		return Array.from({ length: limit }, (_, i) => i + 1);
	}

	next() {
		console.log("prev")
		this.currentPage++;
		this.renderData();
	}
	
	prev() {
		console.log("next")
		this.currentPage--;
		this.renderData();
	}

	public selectAddress(address: any): void {
		console.info('Selected Address: ', address);
		this.selectRecord.emit(address);
	}

}
